export default __webpack_public_path__ + "static/media/Logo.ae3e5902.png";